'use client';

import { _ as _extends, a as _object_destructuring_empty } from './cc-Bl2td_aX.js';
import { jsx } from 'react/jsx-runtime';
import { useTheme } from 'next-themes';
import { Toaster as Toaster$1 } from 'sonner';
const Toaster = _param => {
  var props = _extends({}, _object_destructuring_empty(_param));
  const {
    theme = "system"
  } = useTheme();
  return /*#__PURE__*/jsx(Toaster$1, _extends({
    theme: theme,
    className: "toaster group",
    style: {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)"
    }
  }, props));
};
export { Toaster };